import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import './notice.css'

// COMPONENTS
import { Column } from '@components/templates/column'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { links } from '@constants'
import { createAuthenticatedLoader } from '@utils/loaders'


const Component: FC<{}> = () => {
    const navigate = useNavigate()

    function handleBack() {
        navigate(-1)
    }

    return (<>
        <Column>
            <Column.Content>
                <Column.Header.Start>
                    <a onClick={handleBack}>
                        <img src="/icons/arrow-left.svg" alt="back" style={{ width: '1.4rem', height: '1.4rem' }} draggable="false" />
                    </a>
                </Column.Header.Start>
                <div className="purchase-notice">
                    <h2 style={{ textAlign: 'center' }}>Splitcard Purchases Notice</h2>
                    <p style={{ textAlign: 'center' }}>For safety and security purposes a Splitcard cannot be used to purchase any of the following:</p>
                    <List className='categories'>
                        <p><strong>Gas Stations</strong></p>
                        <p><strong>Adult Sites</strong></p>
                        <p><strong>Weapons</strong></p>
                        <p><strong>Gambling Funds</strong></p>
                        <p><strong>Illegal Substances</strong></p>
                        <p><strong>Cash Apps</strong></p>
                    </List>
                    <p style={{ textAlign: 'center' }}>
                        Any attempt to purchase something that fits into these categories or any purchase that Splitcard deems as a banned category will be declined.
                        Reminder you are not receiving a physical card. Your issued card is per group and virtual.
                    </p>
                    <p className="support">
                        For more information visit our FAQ's<br /><a onClick={() => window.open(links.FAQs, '_blank')}>splitcard.com/faq-&-support</a>
                    </p>
                </div>
            </Column.Content>
        </Column>
    </>)
}

const List: FC<React.HTMLAttributes<HTMLUListElement>> = (props) => {
    const { children, ...ulProps } = props
    return (
        <ul {...ulProps}>
            {React.Children.map(children, (child) => {
                if (React.isValidElement(child) && child.type === 'li') return child
                else return <li>{child}</li>
            })}
        </ul>
    )
}

const loader = createAuthenticatedLoader(() => null)

const NoticeRoute: RouteObject = {
    path: "notice",
    Component,
    loader,
}

export default NoticeRoute
